import { Link } from 'react-router-dom';
import style from './Blogs.module.css';
import { useTranslation } from 'react-i18next';
import noImage from '../../assets/images/noImage.png';
import { basename } from './../../configiration/config';
import { imgResize } from './../../utilities/imageResize';

const Blog = ({blog, section,blogLocale,blogDiffLocale}) => {
    const { t } = useTranslation();

	return (
		<Link to={`${basename}/blogs/${section.slug}/${blog && blog.slug}`} className={`${style.articleContainer} px-0`}>
            <div className={`${style.article} `}>
                <div className={`${style.articleImg}`}>
                    <img src={imgResize(blog.image,500,0)} className="w-100" alt="articleImg" onError={(e)=>{e.target.src=noImage}}/>
                </div>
                <div className="card-body text-start px-0 ">
                 <div className={style.titleWrapper}>
                        <h5 className={`${style.articleTitle} card-title`}>
                            {blogLocale && blogLocale.length >0 ? blogLocale[0].title
                            :
                            blogDiffLocale && blogDiffLocale.length >0 && blogDiffLocale[0].title
                            }
                        </h5>
                 </div>
                    <div className={`${style.articleDesc} card-text`}>
                        <p>{blogLocale && blogLocale.length >0 ? blogLocale[0].short_description
                        : 
                        blogDiffLocale && blogDiffLocale.length >0 && blogDiffLocale[0].short_description
                        }    
                    </p>
                    </div>
                    <button className={`${style.readMoreBtn}`}>{t('read-more')}</button>
                </div>
            </div>
        </Link>
	);
}

export default Blog;